import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';
import { MdEdit } from "react-icons/md";
import {Box,Button,styled,Dialog,DialogTitle,DialogActions,IconButton,TextField} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CandidatePersonalAction } from "../../../Redux/action/CandidatePersonalAction";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

const CandidateEducation = () => {
  const { userResult } = useSelector((state) => state.Auth);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({
    intermediate: "",
    graduation: "",
    postGraduation: "",
    certification: "",
    chooseIndustry: "",
    // pincode: "",
    skillsCategory: "",

  });

  const {
    intermediate,
    graduation,
    postGraduation,
    certification,
    chooseIndustry,
    // pincode,
    skillsCategory,
  } = data;

  const dispatch = useDispatch();

  const userInfo = useSelector((state) => state.Profile.result);

  const user_personal = useSelector((state)=> state?.CandidatePersonal?.data)
  
  let userData = userInfo;
//   useEffect(() => {
//     if (userData) {
//       setData({ ...userData });
//     }
//   }, [userData]);

  useEffect(() => {
    if (user_personal) {
      setData({ ...user_personal });
    }
    else if(userData){
        setData({ ...userData });
    }
  }, [user_personal,dispatch,userData]);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const candidateId = userResult?.userid;;
 

  const handleSubmit = (e) => {
    e.preventDefault();
    let content = {
      candidateId,
      intermediate,
      graduation,
      postGraduation,
      certification,
      chooseIndustry,
      // pincode,
      skillsCategory
    };

    dispatch(CandidatePersonalAction(content));
  };

  console.log('inter--', intermediate)
  const location = useLocation();
  return (
    <>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
          Update Your Personal Educational Information.
        </BootstrapDialogTitle>
        <form onSubmit={handleSubmit}>
          <Box
            sx={{
              width: 500,
              maxWidth: '100%',
            }}
          >
            <TextField fullWidth label="Intermediate" value={intermediate} name="intermediate"
              onChange={handleInputChange} />
            <TextField fullWidth label="Graduation" value={graduation} name="graduation"
              onChange={handleInputChange} />
            <TextField fullWidth label="Post Graduation" name="postGraduation" value={postGraduation} onChange={handleInputChange} />
            <TextField fullWidth label="Certification" name="certification" value={certification} onChange={handleInputChange} />
            <TextField fullWidth label="Choose Industry" name="chooseIndustry" value={chooseIndustry} onChange={handleInputChange} />
            {/* <TextField fullWidth label="Pincode" name="pincode" value={pincode} onChange={handleInputChange} /> */}
            <TextField fullWidth label="Skills Category" name="skillsCategory" value={skillsCategory} onChange={handleInputChange} />
            {/* <TextField fullWidth label="Interest" name="interest" value={interest} onChange={handleInputChange} /> */}
          </Box>
          <DialogActions>
            <Button autoFocus type="submit" onClick={handleClose}>
              Save changes
            </Button>
          </DialogActions>
        </form>
      </BootstrapDialog>
      <div className="">
        <div className='edit-button'>
          <div className='overview tag_over'>
            <span style={{ fontWeight: "bold" }}></span>
            {location.state === null ? <><span onClick={handleClickOpen}><MdEdit /></span></> : console.log("data")}
          </div>
        </div>
        <div className="contact_info-body">
          <div className="personal_info">
            <div className='personal_detail'><h5>Intermediate</h5></div>
            <div className="">
              {intermediate ? <p className="">{intermediate}</p> : <p className="Warning_data">Please Fill Your intermediate</p>}
            </div>
          </div>
        </div>
        <div className='personal_hr'> <hr /></div>
        <div className="contact_info-body">
          <div className="personal_info">
            <div className='personal_detail'><h5>Graduation</h5></div>
            <div className="">
              {graduation ? <p className="">{graduation}</p> : <p className="Warning_data">Please Fill Your graduation</p>}
            </div>
          </div>
        </div>
        <div className='personal_hr'> <hr /></div>
        <div className="contact_info-body">
          <div className="personal_info">
            <div className='personal_detail'><h5>Post Graduation</h5></div>
            <div className="">
              {postGraduation ? <p className="">{postGraduation}</p> : <p className="Warning_data">Please Fill Your postGraduation</p>}
            </div>
          </div>
        </div>
        <div className='personal_hr'> <hr /></div>
        <div className="contact_info-body">
          <div className="personal_info">
            <div className='personal_detail'><h5>Certification</h5></div>
            <div className="">
              {certification ? <p className="">{certification}</p> : <p className="Warning_data">Please Fill Your certification</p>}
            </div>
          </div>
        </div>
        <div className='personal_hr'> <hr /></div>
        <div className="contact_info-body">
          <div className="personal_info">
            <div className='personal_detail'><h5>Choose industry</h5></div>
            <div className="">
              {chooseIndustry ? <p className="">{chooseIndustry}</p> : <p className="Warning_data">Please Fill Your chooseIndustry</p>}
            </div>
          </div>
        </div>
        {/* <div className='personal_hr'> <hr /></div>
        <div className="contact_info-body">
          <div className="personal_info">
            <div className='personal_detail'>
              <h5>Pin-Code</h5></div>
            <div className="">
              {userInfo.pincode !== null && userInfo.pincode !== "" ? <p className="">{userInfo.pincode}</p> : <p className="Warning_data">Please Fill Your pincode</p>}
            </div>
          </div>

        </div> */}
        <div className='personal_hr'> <hr /></div>
        <div className="contact_info-body">
          <div className="personal_info">
            <div className='personal_detail'><h5>Skills Category</h5></div>
            <div className="">
              {skillsCategory ? <p className="">{skillsCategory}</p> : <p className="Warning_data">Please Fill Your skillsCategory</p>}
            </div>
          </div>
        </div>
      </div></>
  )
}

export default CandidateEducation